module.exports = __webpack_public_path__ + "img/ic-bone.9f61c3e2.svg";